<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Einstellungen für den 'Unsubscribe Bereich'</h4>
      </div>
      <div class="card-body">
        <div class="form-group row">
          <col-label>Lebenszeit der Tokens (Tage)</col-label>
          <div class="col-8">
            <vue-slider
              tooltip="false"
              :min="3"
              :max="60"
              step="1"
              id="unsubscribeTokenLifetimeInput"
              v-model="data.unsubscribeTokenLifetime"
            ></vue-slider>
            <div>gewählt: {{ data.unsubscribeTokenLifetime }}</div>
          </div>
        </div>
        <div class="form-group row">
          <col-label>Bezeichnung des Link</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.unsubscribeLinkLabel"
            />
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>Email-Adresse</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.unsubscribeResponseMailAddress"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Email-Betreff</col-label>
          <div class="col-8">
            <input
              type="text"
              class="form-control"
              v-model="data.unsubscribeResponseMailSubject"
            />
          </div>
        </div>
        <div class="form-group row">
          <col-label>Email-Text</col-label>
          <div class="col-8">
            <vue-editor
              class="form-control"
              v-model="data.unsubscribeResponseMailBody"
              :editorToolbar="customToolbar"
            />
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <col-label>Funktionalität</col-label>
          <div class="col-8">
            <div class="custom-control custom-checkbox">
              <input
                class="form-check-input custom-control-input"
                type="checkbox"
                v-model="data.unsubscribeLinkEnabled"
                id="unsubscribeLinkEnabled"
              />
              <label
                class="form-check-label custom-control-label"
                for="unsubscribeLinkEnabled"
                >Link im Email-Template</label
              >
            </div>
            <div class="custom-control custom-checkbox">
              <input
                class="form-check-input custom-control-input"
                type="checkbox"
                v-model="data.unsubscribeHeaderEnabled"
                id="unsubscribeHeaderEnabled"
              />
              <label
                class="form-check-label custom-control-label"
                for="unsubscribeHeaderEnabled"
                >Link im Email-Header</label
              >
            </div>
          </div>
        </div>
      </div>
      <br /><br />
      <div class="col-11">
        <v-button @click="persist()" class="btn btn-primary float-right"
          >Speichern</v-button
        >
      </div>
    </div>
  </section>
</template>

<script>
import { VueEditor } from "vue2-editor";

export default {
  components: {
    VueEditor
  },
  created() {
    this.$store.dispatch("setting/all").then(() => {
      const settings = this.$store.getters["setting/all"];
      Object.keys(settings).forEach(key => {
        this.data[key] = settings[key];
      });
      this.data.unsubscribeResponseMailBody = decodeURI(
        this.data.unsubscribeResponseMailBody
      );
    });
  },
  methods: {
    persist() {
      this.data.unsubscribeLinkLabel = this.data.unsubscribeLinkLabel.replace(
        "<p>",
        ""
      );
      this.data.unsubscribeLinkLabel = this.data.unsubscribeLinkLabel.replace(
        "</p>",
        ""
      );
      this.data.unsubscribeResponseMailBody = this.data.unsubscribeResponseMailBody.replace(
        "<p>",
        ""
      );
      this.data.unsubscribeResponseMailBody = this.data.unsubscribeResponseMailBody.replace(
        "</p>",
        ""
      );
      this.data.unsubscribeResponseMailBody = encodeURI(
        this.data.unsubscribeResponseMailBody
      );

      const unsubscribeSettings = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", unsubscribeSettings).then(() => {
        this.$notify({
          title: "Unsubscribe Einstellungen gespeichert",
          type: "success"
        });
      });
      this.data.unsubscribeResponseMailBody = decodeURI(
        this.data.unsubscribeResponseMailBody
      );
    }
  },
  data() {
    return {
      customToolbar: [
        { header: [false] },
        "bold",
        "italic",
        "underline",
        "strike",
        "code-block",
        { list: "ordered" },
        { list: "bullet" },
        { color: [] },
        { background: [] },
        "clean"
      ],
      data: {
        unsubscribeLinkLabel: "",
        unsubscribeTokenLifetime: 3,
        unsubscribeResponseMailAddress: "",
        unsubscribeResponseMailSubject: "",
        unsubscribeResponseMailBody: "",
        unsubscribeHeaderEnabled: true
      }
    };
  }
};
</script>
